import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    categoryId: String,
    categoryName: String
  }

  connect() {
    if (this.hasCategoryIdValue && this.hasCategoryNameValue && typeof gtag === 'function') {
      gtag('event', 'category_view', {
        category_id: this.categoryIdValue,
        category_name: this.categoryNameValue,
      })
    }
  }
}